var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export default class TintAnalyticsClientProxy {
  constructor(enabled = true) {
    this.enabled = enabled;
  }
  track(name, params) {
    return __async(this, null, function* () {
      if (this.enabled) {
        let event = params;
        event.type = "tint-analytics-track";
        event.eventName = name;
        return window.parent.postMessage(JSON.stringify(event), "*");
      }
    });
  }
  recordTraits(params) {
    return __async(this, null, function* () {
      if (this.enabled) {
        let event = params;
        event.type = "tint-analytics-record-traits";
        return window.parent.postMessage(JSON.stringify(event), "*");
      }
    });
  }
}
